import { parseCellId } from '@cards/engine';
import { defineGameCard, onResolve } from '../authoring/index.js';
import { plannedTarget } from './helpers.js';
export const PowerRerouteCard = defineGameCard({
    id: 'power_reroute',
    gameplay: {
        type: 'SPELL', cost: 1,
        planning: {
            target: 'unit+cell', unitFilter: 'ally',
            validatePlan(state, playerId, plan) {
                const target = plan.targetInstanceId === undefined ? undefined : state.instances[plan.targetInstanceId];
                const destination = plan.targetCellId === undefined ? undefined : state.board.cells[plan.targetCellId];
                if (target?.cellId === undefined || destination === undefined || destination.occupantId !== null)
                    return false;
                if (destination.side !== state.players[playerId]?.side)
                    return false;
                return Math.abs(parseCellId(target.cellId).tableId - parseCellId(destination.id).tableId) === 1;
            },
        },
    },
    presentation: {
        name: 'Переброс мощности',
        description: 'Переместите союзную карту в свободную ячейку соседней локации и охладите её на 1. Если в новой локации нет других ваших карт, она получает +1 к атаке.',
        glyph: {
            colors: ['#10213A', '#5F91B2', '#344D61', '#815F5F', '#FBA133'],
            rows: [
                '....111111111111....',
                '..1122222222222211..',
                '.122333333333333221.',
                '.122113311113311221.',
                '.122311111111113221.',
                '.122333333333333221.',
                '.122311111111113221.',
                '.122314555444413221.',
                '.122314555544413221.',
                '.122314555554413221.',
                '.122314555555413221.',
                '.122314555555413221.',
                '.122314455555413221.',
                '.122314445555413221.',
                '.122333333333333221.',
                '.112233333333332211.',
                '.122333333333333221.',
                '.133311111111113321.',
                '.133331311113333321.',
                '..1111111111111111..',
            ],
        },
    },
    role: 'playable',
    abilities: [
        onResolve((ctx) => {
            const targetId = plannedTarget(ctx);
            const destinationId = ctx.plan?.kind === 'SPELL' ? ctx.plan.targetCellId : undefined;
            if (targetId === undefined || destinationId === undefined)
                return;
            const destination = ctx.q.cell(destinationId);
            if (destination === null)
                return;
            const hadAlly = ctx.q.unitsOf(ctx.self.controllerId)
                .some((unit) => unit.id !== targetId && unit.cellId !== undefined
                && parseCellId(unit.cellId).tableId === destination.tableId);
            ctx.ops.moveUnit(targetId, destinationId);
            ctx.ops.cool(targetId, 1);
            if (!hadAlly) {
                ctx.ops.modifyStat(targetId, 'attack', 1, ctx.self.id);
            }
        }),
    ],
    ui: { mechanics: ['cool'] },
});
//# sourceMappingURL=power-reroute.js.map